var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74219 20.67C2.74219 17.0802 2.74219 15.2853 3.85739 14.1701C4.97259 13.0549 6.76748 13.0549 10.3573 13.0549H20.5107C24.1005 13.0549 25.8954 13.0549 27.0106 14.1701C28.1258 15.2853 28.1258 17.0802 28.1258 20.67C28.1258 24.2598 28.1258 26.0547 27.0106 27.1699C25.8954 28.2851 24.1005 28.2851 20.5107 28.2851H10.3573C6.76748 28.2851 4.97259 28.2851 3.85739 27.1699C2.74219 26.0547 2.74219 24.2598 2.74219 20.67Z",
    stroke: "#8B739B",
    strokeWidth: 1.67732
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81641 13.0548V10.5164C7.81641 6.31076 11.2258 2.90137 15.4315 2.90137C19.6372 2.90137 23.0466 6.31076 23.0466 10.5164V13.0548",
    stroke: "#8B739B",
    strokeWidth: 1.67732,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3555 20.6699H10.3669M15.4208 20.6699H15.4322M20.4975 20.6699H20.5089",
    stroke: "#8B739B",
    strokeWidth: 2.23643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.b831f15be79ed4e089c58dbb8fddc60a.svg";
export { ForwardRef as ReactComponent };